<template>

  <div class="payment-center">
    <a-modal title="年费支付" v-model="visible" :footer="null" :width="475" :maskClosable='false'>
        
      <a-form :form="payMentForm">
        <a-form-item label="剩余天数：" v-bind='payFormItemLayout'>
          <h4 class="label-margin" style="font-weight:bold;"> <span style="font-size:18px;">{{expireDate }}</span> 天</h4>
        </a-form-item>
        <a-form-item label="购买年限：" v-bind='payFormItemLayout'>
          <a-select
            size='small'
            class="label-margin"  
            style="width:50px;"
            v-decorator="['ageLimit',{
              initialValue:ageLimit
            }]"
            @change="ageLimitChange"
          >
            <a-select-option v-for="(item,index) in ageLimits" :key="index" :value="item.value">{{item.value}}</a-select-option>
          </a-select>
          <span style="padding:0 8px;color:rgba(0, 0, 0, 0.85);font-weight:bold;">年</span>
        </a-form-item>
        <a-form-item label="支付费用：" v-bind='payFormItemLayout'>
          <h4 class="label-margin"  style="font-weight:bold;"> <span style="font-size:18px;">{{price }}</span> 元</h4>
        </a-form-item>
        <a-form-item label="支付方式：" v-bind='payFormItemLayout'>
          <div class="payType active label-margin">
            <img src="../../../assets/images/payMent/AliPay.png" alt="">
          </div>
          <!-- <div class="payType">
            <img src="../../../assets/images/payMent/WeChatPay.png" alt="">
          </div> -->
        </a-form-item>
        <a-form-item label="费用说明：" v-bind='payFormItemLayout'>
          <p style="line-height:20px;width:253px;">支付说明：年费为800元一年，包含证书管理（证书上传、证书变更、证书预览、证书下载、证书分享、证书统计、证书监控预警）、报告管理（报告上传、报告预览、报告下载、报告分享、报告统计）、个人中心及统计相关功能。</p>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 19, offset: 5 }" >
          <a-button type="primary" style="width:200px;" @click="payhandleOk"> 确定购买 </a-button>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal v-model="payingVisible" title="" :footer="null" :width="475" :maskClosable='false'	>

      <p style="font-size:17px;margin:20px 0; text-align:center;color:#000;">正在使用支付宝支付,支付完成前请不要关闭窗口</p>
      <a-button type="primary" @click="paySuccess" style="margin-right:20px;margin-left:52px;text-align:center;"> 我已充值成功 </a-button>
      <a-button @click="payFailure" style="text-align:center;"> 支付遇到问题，重新充值 </a-button>
    </a-modal>

  </div>
</template>
<script>

import { 
  payMent,
} from '@/api/user'

  const ageLimits = [
    {value:1},
    {value:2},
    {value:3},
    {value:4},
    {value:5},
  ]
export default {
  data() {
    return {
      ageLimits,
      payFormItemLayout:{
        labelCol: {
            span: 9
        },
        wrapperCol: {
            span: 15
        },
      },
      ageLimit:1,
      payMentForm:this.$form.createForm(this),
      expireDate:0,
      visible:false,
      price:800,
      // price:0.01,
      payingVisible:false,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init(){
      // this.expireDate = this.$route.query.expireDate
    },
    ageLimitChange(value){
      this.price = 800*value
      // this.price = 0.01*value
      // console.log()
    },
    resetFields(e){
      this.price=800
      // this.price=0.01
      this.expireDate=0
      this.payMentForm.resetFields()
    },
    payhandleOk(){
      let that = this
      payMent({number:that.price}).then(res => {
        let el = document.createElement("a");
        document.body.appendChild(el);
        el.href = res; 
        el.target = '_new'; 
        el.click();
        document.body.removeChild(el);
        this.payingVisible = true
      }).catch(error => {

      })
    },
    
    paySuccess(){
      this.visible = false;
      this.payingVisible = false;
      this.$emit("paySuccess");
    },
    payFailure(){
      this.visible = true;
      this.payingVisible = false;
    },
  },
  watch: {
    
    visible(val){
      if(!val){
        this.resetFields()

      }
    },
  }
}
</script>

<style lang="less" scoped>
  .payment-center{
    height: 100%;
    background-color: #fff;
    
  }
  .label-margin{
    margin-left:18px;
  }
  .payType{
    float: left;
    // display: -ms-flexbox;
    display: flex;
    // -ms-flex-align: center;
    align-items: center;
    // -ms-flex-pack: center;
    justify-content: center;
    // margin-right: 18px;
    width: 122px;
    height: 37px;
    border: 1px solid #eee;
    background-color: #ffffff;
    cursor: pointer;
    position: relative;
  }
  .payType.active{
    border: 1px solid transparent;
    background: url('../../../assets/images/payMent/active.png') no-repeat center center;
    background-size: 100% 100%;
  }
  .ant-form-item{
    margin-bottom:12px;
    
  }
  .ant-form-item-label{
      text-align: left;
    }
</style>